import React, { useEffect, useState } from "react";
import { axios } from "../../../../Global";
import { setAppError,setBreadCrumb } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PromptElement from "../../PromptElement";
import ListDataJobPosition from "./ListDataJobPosition";
import { printValidationError } from "../../../../utils/functions";
import { checkAccessFn } from "../../../../utils/checkAccess";
import AddEditJobPosition from "./AddEditJobPosition";
import Breadcrumb from "../../../../utils/BreadCrumb";

export default function JobPosition(props) {
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [listLoading,setListLoading] =useState(false)
  const [clientList, setClientList] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create") {
      setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const token = localStorage.getItem("token");
  const Nodetoken = localStorage.getItem("nodeToken");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  const getJobPositions = () => {
    setListLoading(true)
    axios
      .get("/dashboard/job-position", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setClientList(res.data.data);
        setListLoading(false);
      })
      .catch((err) => {
        dispatch(setAppError({ msg: err.message }));
        setListLoading(false);
      });
  };
  useEffect(() => {
    getJobPositions();
  }, []);

  const submitForm = async (event) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const body = {
        name,
      };
      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/job-position`, body, {
          headers: { Authorization: `Bearer ${token}` },
        });
      } else if (addOrEdit.method === "edit") {
        response = await axios.put(
          `/dashboard/job-position/${addOrEdit.editId}`,
          body,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      getJobPositions();
      const data = response.data.data;
      if (data) {
        navigate("/dashboard/actual-profession");
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      printValidationError(err, "jobPosition");
      setSubmitFormLoading(false);
      dispatch(setAppError({ msg: err.message }));
    }
  };
  const cancelForm = () => {
    navigate("/dashboard/actual-profession");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id, data) => {
    navigate(`/dashboard/actual-profession/edit/${id}`);
    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        await new Promise((resolve) => setTimeout(resolve, 200));
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          editId: id,
        }));
        setName(data.name);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(`/dashboard/job-position/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        getJobPositions();
        if (response.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(setAppError({ msg: err?.response?.data.message }));
          }
        } else {
          dispatch(setAppError({ msg: err.message }));
        }
        setLoading((p) => ({ ...p, delete: false }));
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setName("");
    setDescription("");
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const isCreateMode = location.pathname.endsWith("/actual-profession/create");
  const isEditMode = location.pathname.includes("/actual-profession/edit");

  useEffect(() => {
    if ((isCreateMode || isEditMode) && !addOrEdit.method) {
      setAddOrEdit({});
      navigate("/dashboard/actual-profession");
    }
  }, []);

  const commonItems = [
    { label: "ACTUAL PROFESSION", link: "/dashboard/actual-profession" },
  ];
  const breadcrumbItems = isEditMode
    ? [...commonItems, { label: "EDIT", link: "" }]
    : isCreateMode
    ? [
        ...commonItems,
        { label: "CREATE", link: "/dashboard/actual-profession" },
      ]
      : commonItems;
  
  
   useEffect(() => {
     dispatch(setBreadCrumb(breadcrumbItems));
   }, [location.pathname]);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
            <ListDataJobPosition
              list={clientList}
              editData={editData}
              deleteData={setShowPromptElement}
              loading={loading}
              listLoading={listLoading}
              column={4}
              titles={["S.No.", "Actual Profession", "Action"]}
              addData={addData}
            />
          </>
        )}
        {addOrEdit.open &&
          ((checkAccess("Job Position", "job-position-create") &&
            addOrEdit.method === "add") ||
            (checkAccess("Job Position", "job-position-edit") &&
              addOrEdit.method === "edit")) && (
            <AddEditJobPosition
              component="jobPosition"
              form={[
                {
                  type: "textarea",
                  text: "Actual Profession",
                  name: "name",
                  value: name,
                  update: setName,
                  columnName: "name",
                },
                // {
                //   type: "textarea",
                //   text: "Short Description",
                //   name: "description",
                //   value: description,
                //   update: setDescription,
                //   columnName: "short_description",
                // },
              ]}
              submitForm={submitForm}
              cancelForm={cancelForm}
              submitFormLoading={submitFormLoading}
              isEditMode={isEditMode}
              loadedValues={
                addOrEdit.method === "edit" && addOrEdit.loadedValues
                  ? true
                  : false
              }
            />
          )}
      </div>
    </>
  );
}
